<script setup>
import {Link} from "@inertiajs/vue3";
import {reactive} from "vue";

const props = defineProps({
    guide: Object,
    parentGuide: Object,
    category: Object,
    categories: Array,
    classes: String
})

const state = reactive({
    categories: JSON.parse(JSON.stringify(props.categories)).map(category => {
        category.guides = category.guides.map(guide => {
            guide.is_active = (!props.parentGuide && props.guide.code === guide.code);
            guide.is_open = ((props.parentGuide && props.parentGuide.code === guide.code) || (!props.parentGuide && props.guide.code === guide.code))
            guide.guides = guide.guides.map(subGuide => {
                subGuide.is_active = (props.guide.code === subGuide.code);
                subGuide.is_open = false;

                return subGuide;
            });

            return guide;
        })

        return category;
    })
});

function toggle(guide) {
    guide.is_open = !guide.is_open;
}
</script>

<template>
    <nav id="nav" :class="classes">
        <ul>
            <li v-for="(categoryItem, index) in state.categories" :class="index === 0 ? '' : 'mt-12 lg:mt-8'">
                <h5 class="mb-8 lg:mb-3 font-semibold text-white">{{ categoryItem.title }}</h5>
                <ul>
                    <li v-for="guideItem in categoryItem.guides">
                        <div :class="{
                            'flex align-middle border-l py-1 pl-2 border-slate-900/10 dark:border-slate-100/10 hover:border-orange dark:hover:border-orange hover:text-orange transition-all duration-150': true,
                            '!border-orange': guideItem.is_active
                        }">
                            <span :class="{
                                'px-1 cursor-pointer': true,
                                'opacity-0 pointer-events-none': !guideItem.guides.length
                            }" @click="toggle(guideItem)">
                                <svg width="3" height="20" viewBox="0 0 3 6"
                                     :class="{
                                        'mr-2 text-slate-400 overflow-visible group-hover:text-slate-600 dark:text-slate-600 dark:group-hover:text-slate-500': true,
                                        'rotate-90': guideItem.is_open
                                     }">
                                    <path d="M0 0L3 3L0 6" fill="none" stroke="currentColor" stroke-width="1.5"
                                          stroke-linecap="round"></path>
                                </svg>
                            </span>
                            <Link
                                :class="{
                                    'text-orange border-orange font-semibold': guideItem.is_active,
                                }"
                                :href="'/guides/' + categoryItem.code + '/' + guideItem.code">
                                <span>{{ guideItem.title + ' ' +  (guideItem.isActive ? '' : ' (черновик)') }}</span>
                            </Link>
                        </div>
                        <ul  v-if="guideItem.is_open" class="guide-list">
                            <li v-for="guideSubItem in guideItem.guides">
                                <div :class="{
                                    'flex align-middle border-l py-1 pl-2 border-slate-900/10 dark:border-slate-100/10 hover:border-orange dark:hover:border-orange hover:text-orange transition-all duration-150': true,
                                    '!border-orange': guideSubItem.is_active
                                }">
                                    <Link
                                        :class="{
                                            'pl-10': true,
                                            'text-orange border-orange font-semibold': guideSubItem.is_active,
                                        }"
                                        :href="'/guides/' + categoryItem.code + '/' + guideItem.code + '/' + guideSubItem.code">
                                        {{ guideSubItem.title + ' ' +  (guideSubItem.isActive ? '' : ' (черновик)') }}
                                    </Link>
                                </div>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
        </ul>
    </nav>
</template>
